import axios, { isAxiosError } from "axios"
import { useEffect, useState } from "react"
import Swal from "sweetalert2"
import Loadingwrapper from "../../../component/LoadingWrapper"
import useAddImageToCollection from "../../../hooks/useAddImageToCollection"
import useCollectionNames from "../../../hooks/useCollectionNames"
import Image from "../../BuildDesigns/Image"
import useMixpanelTrack from "../../../hooks/useMixpanelTracking"

const TrendImages = ({ tag, value, category, gender, shareTag, shareValue }) => {
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(1)
  const [socialCount, setSocialCount] = useState(1)
  const [retailerCount, setRetailerCount] = useState(1)
  const [socialImages, setSocialImages] = useState([])
  const [retailerImages, setRetailerImages] = useState([])
  const [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames] = useCollectionNames()
  const addImageToCollection = useAddImageToCollection()
  const [loading, setLoading] = useState(false)
  const TrackEvent = useMixpanelTrack()
  const [resultsLoading, setResultsLoading] = useState(false)
  const [heading, setHeading] = useState('')
  const limit = 100



  useEffect(() => {
    setCount(1)
    setPage(1)
  }, [])


  const getImages = async (signal) => {
    setLoading(true)
    setResultsLoading(true)
    try {
      let tagsQuery = `&tag-0=${encodeURIComponent(shareTag)}&value-0=${encodeURIComponent(shareValue)}`

      const resp = await axios.get(`/api/build-designs/images?gender=${gender == 'F' ? 'Female' : 'Male'}&category=${encodeURIComponent(category)}&breakdown-level=${1}&tag=${tag}&value=${value}${tagsQuery}&page=${page}`, { signal })
      setLoading(false)
      setResultsLoading(false)
      setSocialCount(resp.data.socialCount)
      setRetailerCount(resp.data.retailerCount)
      setSocialImages(prev => {
        const newRes = [...prev, ...resp.data.socialImages]
        return newRes
      })
      setRetailerImages(prev => {
        const newRes = [...prev, ...resp.data.retailerImages]
        return newRes;
      })
      setCount(Math.max(resp.data.socialCount, resp.data.retailerCount))
    } catch (e) {
      if (!isAxiosError(e)) {
        console.log(e)
        setLoading(false)
      }
    }
  }
  useEffect(() => {
    setHeading(`${value}(${tag}) ,${shareValue}(${shareTag}) `)
    const abortController = new AbortController();
    const signal = abortController.signal;
    try {
      getImages(signal)
    } catch (e) {
      console.error(e)
    }
    return () => {
      abortController.abort()
    }
  }, [gender, category, tag, value, shareTag, shareValue, page])


  const socialAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, socialcollectionSets, 'social', getCollectionNames);
  }

  const retailerAddImageToCollectionWrapper = (image, collectionId) => {
    addImageToCollection(image._id, collectionId, retailercollectionSets, 'retailer', getCollectionNames);
  }

  const addAllImagesToCollection = (collectionId) => {
    addImageToCollection(null, collectionId, null, null, getCollectionNames, true, retailerImages.map(p => p._id), socialImages.map(p => p._id))
  }

  return <div className={`${"w-[80vw] h-[80vh]"} bg-white`}>
    <h3 className="text-center font-semibold text-[20px]">{heading} Trend Images</h3>
    <div className="flex justify-end">
      <div>
        <button className="primary-btn" onClick={() => { setPage(prev => prev - 1) }} disabled={page <= 1}>prev</button> {page}/{Math.ceil(count / limit)}
        <button className="primary-btn" onClick={() => { setPage(prev => prev + 1) }} disabled={page >= Math.ceil(count / limit)}>next</button>
      </div>
    </div>


    <Loadingwrapper loading={loading} textToShow="Loading Images…">
      {/*
      {socialImages.map(im => <RogSuccessToolTip image={im} trendType={'social'} category={searchParams.get('category')} />)}
      {retailerImages.map(im => <RogSuccessToolTip image={im} trendType={'retailer'} category={searchParams.get('category')} />)}
      */}

      <div className={`flex justify-between pt-10`} >
        <div className="w-[49%] shrink-0">
          <h3 className="text-center font-medium text-lg mb-2">Social Images</h3>
          <div className="flex flex-wrap">
            {socialImages.map(img => <Image image={img} trendType={'social'} addImageToCollection={socialAddImageToCollectionWrapper} allCollectionNames={allCollectionNames} collectionSets={socialcollectionSets} isMainPage={false} fetchCollections={getCollectionNames} />)}
          </div>
        </div>
        <div className="w-0.5 bg-black"></div>
        <div className="w-[49%] shrink-0">
          <h3 className="text-center font-medium text-lg mb-2">Retailer Images</h3>
          <div className="flex flex-wrap">

            {retailerImages.map(img => <Image image={img} trendType={'retailer'} addImageToCollection={retailerAddImageToCollectionWrapper} allCollectionNames={allCollectionNames} collectionSets={retailercollectionSets} isMainPage={false} fetchCollections={getCollectionNames} />)}
          </div>
        </div>
      </div>
    </Loadingwrapper>


  </div >
}

export default TrendImages
